// Base URL Konfiguration für externe Links
export const BASE_URL = 'https://www.kbw.de';

// Helper-Funktion für externe Links
export const getExternalUrl = (path: string): string => {
  return `${BASE_URL}${path}`;
};

// Helper-Funktion um zu prüfen, ob ein Link extern ist
export const isExternalLink = (href: string): boolean => {
  return href.startsWith('/') && !href.startsWith('/#');
};